module.exports = __webpack_public_path__ + "img/setting.d2417380.svg";